import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { S25IconComponent } from "../../modules/s25-icon/s25.icon.component";

@Component({
    selector: "s25-ng-publisher-status-cell",
    template: `
        @if (status() === "error") {
            <s25-ng-icon class="c-svgIcon c-danger" type="warningYield" [ariaLabel]="'Status: Error'" />
        } @else {
            <s25-ng-icon class="c-svgIcon c-success" type="check" [ariaLabel]="'Status: Ok'" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25IconComponent],
})
export class PublisherStatusCell {
    readonly status = input<string>("");
}
